import { getActionTypeFn } from 'shared/state-utils'
export const FEATURE_NAME = 'Language'
export const getActionType = getActionTypeFn(FEATURE_NAME)
